import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';

import viewModes from 'shared/constants/view-modes';


@connect(state => ({
  // lazyVideoLists is needed to trigger height calculations
  lazyVideoLists: state.lazyVideoLists,
}))
export default class WidgetHeightByContentSync extends React.Component {

  static propTypes = {
    windowSize: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
  };

  componentDidMount() {
    this.updateTPAParentIfNeeded();
    window.addEventListener('resize', this.updateTPAParentIfNeeded);
  }

  componentDidUpdate() {
    this.updateTPAParentIfNeeded();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTPAParentIfNeeded);
  }

  @autobind
  @debounce
  updateTPAParentIfNeeded() {
    if (!this.container) {
      return;
    }

    const newHeight = Math.ceil(this.container.scrollHeight);

    // Width is not checked, only height
    if (newHeight === 0) {
      return;
    }

    // Getting real bounding rect for our component
    WixSDK.getBoundingRectAndOffsets()
      .then(data => {
        const { rect } = data;

        if (rect.height !== newHeight) {
          if (WixSDK.Utils.getViewMode() === viewModes.EDITOR) {
            // this is for editor
            WixSDK.resizeComponent({ height: newHeight });

            // fix TPA bug. TODO remove
            WixSDK.setHeight(newHeight);
          } else {
            // this is for viewer
            WixSDK.setHeight(newHeight);
          }
        }
      });
  }

  render() {
    const { children, windowSize } = this.props;
    return (
      <div ref={node => (this.container = node)}
           style={{ width: windowSize.width }}
           role="presentation">
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mobile/layouts/home/widget-height-by-content-sync.js